module.exports = __webpack_public_path__ + "img/bubble4-active.bd9f5b07.svg";